import React, { useState } from 'react';
import { Users, BookOpen, Settings, Bot } from 'lucide-react';
import UsersAdmin from './UsersAdmin';
import PersonasAdmin from './PersonasAdmin';
import KipsAdmin from './KipsAdmin';
import AgentsAdmin from './AgentsAdmin';

type Tab = 'users' | 'personas' | 'kips' | 'agents';

const tabs: { id: Tab; label: string; icon: React.ReactNode }[] = [
  { id: 'users', label: 'Users', icon: <Users size={16} /> },
  { id: 'personas', label: 'Personas', icon: <Bot size={16} /> },
  { id: 'kips', label: 'Kips', icon: <BookOpen size={16} /> },
  { id: 'agents', label: 'Agents', icon: <Settings size={16} /> },
];

const AdminDashboard: React.FC = () => {
  const [activeTab, setActiveTab] = useState<Tab>('users');

  return (
    <div className="max-w-7xl mx-auto">
      <div className="mb-8">
        <h1 className="text-3xl font-bold font-poppins text-[#1A1A1A]">Admin</h1>
        <p className="text-[#555555] mt-1">Manage users, personas, and content.</p>
      </div>

      {/* Tab bar */}
      <div className="border-b border-[#DADADA] mb-8">
        <nav className="flex space-x-1 -mb-px">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`flex items-center gap-2 px-4 py-3 text-sm font-medium border-b-2 transition-colors ${
                activeTab === tab.id
                  ? 'border-[#1A1A1A] text-[#1A1A1A]'
                  : 'border-transparent text-[#555555] hover:text-[#1A1A1A] hover:border-[#DADADA]'
              }`}
            >
              {tab.icon}
              {tab.label}
            </button>
          ))}
        </nav>
      </div>

      {/* Tab content */}
      {activeTab === 'users' && <UsersAdmin />}
      {activeTab === 'personas' && <PersonasAdmin />}
      {activeTab === 'kips' && <KipsAdmin />}
      {activeTab === 'agents' && <AgentsAdmin />}
    </div>
  );
};

export default AdminDashboard;
